import script from "./WhatsAppPhonePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppPhonePreview.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppPhonePreview.vue?vue&type=style&index=0&id=55d4e3fd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d4e3fd"]])

export default __exports__